import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-login-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent { 
  @Input() remainingTime = 0;
}
